/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Auto format selected events" |
*
* @param {Auto_Format_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_aria_label = /** @type {((inputs?: Auto_Format_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en forme automatique des evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse automatisch formatieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formatta automaticamente gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formatear automáticamente los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを自動フォーマットする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को स्वचालित रूप से स्वरूपित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática dos eventos selecionados")
	return /** @type {LocalizedString} */ ("Auto format selected events")
});